import API from '../../../../common/http/api.fetch';
import * as TYPE from '../pnp-settings.actions.types';

export const getDocumentCategory = (filter) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-categories`,
            method: 'GET',
            params: {
                offset: filter.offset,
                limit: filter.limit,
                exportFormat: filter.exportFormat,
                exportColumns: filter.exportColumns
            }
        }).then(({ data }) => {
            if (filter.exportFormat) {
                return data;
            }
            dispatch({
                type: 'GRID_FETCH',
                id: 'pnpSettingsDocumentCategoryGrid',
                items: data.items.map((item)=>{
                    return {
                        id: item.dca_id,
                        name : item.name,
                        cat_num: item.cat_num,
                        location: item.loc_id,
                        head_office_name: item.head_office_name,
                        site_location_name: item.site_location_name,
                        department_name: item.department_name,
                        prefix: item.prefix
                    }
                }),
                itemsCount: parseInt(data.items_count)
            })
        });
    }
}

export const saveDocumentCategory = (data) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-category/save`,
            method: 'POST',
            data: {
                id: data.id,
                name: data.name.label,
                location:data.location,
                prefix: data.prefix
            }
        }).then(() => {
                dispatch({
                    type: 'GRID_RELOAD',
                    id: 'pnpSettingsDocumentCategoryGrid'
                })
                if (!data.id) {
                    dispatch({
                        type: TYPE.PNP_DOCUMENT_CATEGORY_RESET,
                        id: 'pnpSettingsDocumentCategory',
                    })
                }
        });
    }
}

export const getDocumentCategoryDetails = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-category/details`,
            method: 'GET',
            params: { id }
        }).then(({ data }) => {
            dispatch({
                type: TYPE.PNP_DOCUMENT_CATEGORY_DETAILS,
                id: 'pnpSettingsDocumentCategory',
                data: data[0][0],
                locations: data[1]
            })
        });
    }
};

export const deleteDocumentCategory = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-category/delete`,
            method: 'GET',
            params: { id }
        }).then(() => {
            dispatch({
                type: 'GRID_RELOAD',
                id: 'pnpSettingsDocumentCategoryGrid'
            })
        });
    }
};
